import '@fortawesome/fontawesome-svg-core/styles.css';
import { css } from '@emotion/react';
import { config } from '@fortawesome/fontawesome-svg-core';
import {
  // eslint-disable-next-line no-restricted-imports
  FontAwesomeIcon as FAIcon,
  type FontAwesomeIconProps as FaIconProps,
} from '@fortawesome/react-fontawesome';
import { forwardRef } from 'react';

// Make sure this is before any other `fontawesome` API calls
config.autoAddCss = false;

export type FaIcon = FaIconProps['icon'];

const iconStyle = css({
  userSelect: 'none',
  '&:focus': {
    outline: 'none',
  },
});

export type FontAwesomeIconProps = FaIconProps & ({
  readonly title: string;
} | {
  readonly onClick?: undefined;
  readonly onMouseDown?: undefined;
  readonly onMouseUp?: undefined;
  readonly onFocus?: undefined;
  readonly onBlur?: undefined;
  readonly title?: string;
});

const getIconAriaAttributes = (props: FontAwesomeIconProps) => {
  if (props.onClick || props.onMouseDown || props.onMouseUp || props.onFocus || props.onBlur) {
    return {
      role: 'button',
      tabIndex: 0,
      'aria-label': props.title ?? 'Interactive icon', // This causes aria-hidden to be set to false. By default, aria-hidden is true and causes an error if the icon is interactive.
    };
  }
  return {};
};

export const FontAwesomeIcon = forwardRef<SVGSVGElement, FontAwesomeIconProps>((props, ref) => (
  <FAIcon
    ref={ref}
    css={iconStyle}
    {...getIconAriaAttributes(props)}
    {...props}
  />
));

FontAwesomeIcon.displayName = 'FontAwesomeIcon';
